/**
 * author: Soumya Shreyas
 */
import React from 'react'
import { withTranslation } from "react-i18next";

function index({t}) {
  return (
   <>
   <div className="py-3 text-center">
        <h6>{t("NoRulesConfigured.label")}</h6>
        <p>{t("NoRulesConfiguredSubtext.label")}</p>
      </div>
   </>
  )
}

export default withTranslation()(index)